// Auto-generated from workflows/workflow_states/ — DO NOT EDIT BY HAND
// Run: npx tsx scripts/generate-workflow-constants.ts

export const STATE_STEPS: Record<string, string[]> = {
  "ee-report": [
    "initiated",
    "data_collection",
    "workforce_profiling",
    "sectoral_analysis",
    "drafting",
    "review"
  ],
  "disciplinarywarning": [
    "pending",
    "hearing",
    "outcome_recorded",
    "warning_issued"
  ],
  "pip": [
    "draft",
    "active",
    "support_implementation",
    "review",
    "outcome_recorded",
    "completed"
  ],
  "termination": [
    "draft",
    "pending_notice",
    "pending_exit_interview",
    "pending_clearance",
    "pending_final_pay",
    "processed"
  ],
  "ohs-calendar-event": [
    "draft",
    "published",
    "inProgress",
    "completed"
  ],
  "ohs-certification": [
    "Active",
    "ExpiringSoon",
    "Expired",
    "Renewed",
    "Archived"
  ],
  "ohsincident": [
    "reported",
    "annexure_capture",
    "medical_treatment",
    "investigating",
    "findings_recorded",
    "dol_reported",
    "closed"
  ],
  "contract-alert": [
    "idle",
    "pending_alert",
    "alert_sent",
    "acknowledged"
  ],
  "onboarding": [
    "initiated",
    "role_assignment",
    "documents_pending",
    "qualification_check",
    "contract_pending",
    "popia_consent",
    "system_provisioning",
    "hr_induction",
    "completed"
  ],
  "department-maintenance": [
    "active",
    "archive_confirmation",
    "archiving"
  ],
  "department": [
    "draft",
    "validating",
    "review",
    "active"
  ],
  "roletemplate-maintenance": [
    "active",
    "editing",
    "validating",
    "nqf_review",
    "saving"
  ],
  "roletemplate-utilization-review": [
    "Scheduled",
    "InReview",
    "ReviewingAssignments",
    "ReviewingUtilization",
    "GeneratingFindings",
    "Reviewed",
    "ActionsApplied",
    "Completed"
  ],
  "roletemplate": [
    "draft",
    "validating",
    "review",
    "active"
  ],
  "course-maintenance": [
    "active",
    "updating"
  ],
  "course": [
    "pending",
    "validating_provider",
    "linking_ofocodes",
    "active"
  ],
  "training": [
    "planned",
    "pending_approval",
    "in_progress",
    "completed",
    "bbbee_recorded"
  ],
  "trainingprovider-bulk-import": [
    "pending",
    "uploaded",
    "validating",
    "preview",
    "importing",
    "completed"
  ],
  "trainingprovider-maintenance": [
    "active",
    "pending_renewal"
  ],
  "trainingprovider": [
    "pending",
    "validating",
    "accreditation_review",
    "banking_details",
    "active"
  ],
  "wsp-atr-report": [
    "initiated",
    "workforce_snapshot",
    "training_aggregation",
    "bbee_calculation",
    "report_generation",
    "review",
    "submitted",
    "acknowledged"
  ],
  "tutoring-session": [
    "draft",
    "scheduled",
    "confirmed",
    "rescheduled",
    "completed",
    "cancelled"
  ],
  "tutoring-agreement": [
    "draft",
    "active",
    "expired",
    "terminated"
  ],
  "tutoring-schedule": [
    "draft",
    "proposed",
    "accepted",
    "rejected",
    "active",
    "completed",
    "cancelled"
  ],
  "tutor": [
    "draft",
    "active",
    "suspended",
    "deactivated"
  ],
  "student": [
    "draft",
    "active",
    "deactivated"
  ],
  "client": [
    "draft",
    "active",
    "deactivated"
  ],
  "service-authorisation": [
    "draft",
    "pending_approval",
    "active",
    "rejected",
    "revoked",
    "expired"
  ]
};

export const WORKFLOW_TYPES: string[] = [
  "ee-report",
  "disciplinarywarning",
  "pip",
  "termination",
  "ohs-calendar-event",
  "ohs-certification",
  "ohsincident",
  "contract-alert",
  "onboarding",
  "department-maintenance",
  "department",
  "roletemplate-maintenance",
  "roletemplate-utilization-review",
  "roletemplate",
  "course-maintenance",
  "course",
  "training",
  "trainingprovider-bulk-import",
  "trainingprovider-maintenance",
  "trainingprovider",
  "wsp-atr-report",
  "tutoring-session",
  "tutoring-agreement",
  "tutoring-schedule",
  "tutor",
  "student",
  "client",
  "service-authorisation"
];

export const TYPE_LABELS: Record<string, string> = {
  "ee-report": "Employment Equity Report Generation",
  "disciplinarywarning": "Disciplinary Warning Process",
  "pip": "Performance Improvement Plan",
  "termination": "Termination Process",
  "ohs-calendar-event": "OHS Calendar Event",
  "ohs-certification": "OHS Certification Tracking",
  "ohsincident": "OHS Incident Process",
  "contract-alert": "Contract Alert",
  "onboarding": "Employee Onboarding",
  "department-maintenance": "Department Maintenance Workflow",
  "department": "Department Maintenance",
  "roletemplate-maintenance": "Role Template Maintenance Workflow",
  "roletemplate-utilization-review": "Role Template Utilization Review",
  "roletemplate": "Role Template Registration",
  "course-maintenance": "Course Maintenance",
  "course": "Course Registration",
  "training": "Training Record Process",
  "trainingprovider-bulk-import": "Training Provider Bulk Import",
  "trainingprovider-maintenance": "Training Provider Maintenance",
  "trainingprovider": "Training Provider Registration",
  "wsp-atr-report": "WSP/ATR Report Generation",
  "tutoring-session": "Tutoring Session",
  "tutoring-agreement": "Tutoring Agreement",
  "tutoring-schedule": "Tutoring Schedule",
  "tutor": "Tutor Management",
  "student": "Student Management",
  "client": "Client Management",
  "service-authorisation": "Service Authorisation"
};

export const RULE_CONFIGURATION: Record<string, { ruleId: string; description: string; guards: string[] }> = {
  "onboarding": {
    ruleId: "onboarding-guards",
    description: "Guards for employee onboarding workflow",
    guards: ["nqf_compliance", "document_verification", "contract_validation"],
  },
  "termination": {
    ruleId: "termination-guards",
    description: "Guards for employee termination workflow",
    guards: ["notice_period", "clearance_check", "final_pay"],
  },
  "disciplinarywarning": {
    ruleId: "disciplinary-guards",
    description: "Guards for disciplinary warning process",
    guards: ["hearing_scheduled", "evidence_reviewed", "penalty_proportional"],
  },
  "pip": {
    ruleId: "pip-guards",
    description: "Guards for performance improvement plan",
    guards: ["manager_approval", "timeline_feasible", "support_allocated"],
  },
  "training": {
    ruleId: "training-guards",
    description: "Guards for training record process",
    guards: ["provider_accredited", "bbbee_compliant", "budget_approved"],
  },
  "ee-report": {
    ruleId: "ee-report-guards",
    description: "Guards for employment equity report",
    guards: ["data_complete", "sectoral_targets_met"],
  },
  "wsp-atr-report": {
    ruleId: "wsatr-guards",
    description: "Guards for WSP/ATR report generation",
    guards: ["workforce_snapshot_valid", "training_data_complete"],
  },
  "ohsincident": {
    ruleId: "ohs-injury-guards",
    description: "Guards for OHS incident process",
    guards: ["incident_documented", "annexure_1_complete", "dol_reported"],
  },
  "ohs-calendar-event": {
    ruleId: "ohs-calendar-guards",
    description: "Guards for OHS calendar event",
    guards: ["event_scheduled", "representatives_notified"],
  },
  "ohs-certification": {
    ruleId: "ohs-certification-guards",
    description: "Guards for OHS certification tracking",
    guards: ["certification_valid", "renewal_on_track"],
  },
  "contract-alert": {
    ruleId: "contract-alert-guards",
    description: "Guards for contract alert workflow",
    guards: ["alert_generated", "acknowledgment_received"],
  },
  "tutoring-session": {
    ruleId: "tutoring-session-guards",
    description: "Guards for tutoring session workflow",
    guards: ["has_tutor_assigned", "has_valid_time_slot", "within_cancellation_window"],
  },
  "tutoring-agreement": {
    ruleId: "tutoring-agreement-guards",
    description: "Guards for tutoring agreement workflow",
    guards: ["has_valid_dates", "has_required_signatures", "has_termination_reason"],
  },
  "tutoring-schedule": {
    ruleId: "tutoring-schedule-guards",
    description: "Guards for tutoring schedule workflow",
    guards: ["has_schedule_details", "within_effective_period", "has_rejection_reason", "has_cancellation_reason"],
  },
  "tutor": {
    ruleId: "tutor-guards",
    description: "Guards for tutor management workflow",
    guards: ["has_valid_qualifications", "has_suspension_reason"],
  },
  "student": {
    ruleId: "student-guards",
    description: "Guards for student management workflow",
    guards: ["has_linked_client"],
  },
  "client": {
    ruleId: "client-guards",
    description: "Guards for client management workflow",
    guards: ["has_contact_person"],
  },
  "service-authorisation": {
    ruleId: "service-authorisation-guards",
    description: "Guards for service authorisation workflow",
    guards: ["has_valid_services", "has_approver_signature", "has_rejection_reason", "has_revocation_reason"],
  },
};
